import styled from 'styled-components';

export const panelContentFontSize = 'min(max(3.5vw, 1.5em), 1.2em)';

export const HouseholdTableScrollableWrapper = styled.div<{ $minWidth: string }>`
  width: 95%;
  height: fit-content;
  font-size: ${panelContentFontSize};
  max-height: 50vh;
  min-width: ${(props) => props.$minWidth};
  flex-shrink: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
  border-radius: min(2vw, 20px);
`;

export const HouseholdTableContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 2ch;
`;

export const Heading = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  /* border-bottom: 1px solid var(--color-text-light); */
`;

export const SectionTitle = styled.div`
  font-family: Jost-SemiBold, sans-serif;
  font-size: min(max(4.5vw, 1.5em), 1.5em);
  margin-top: 1em;
  margin-bottom: 0.6em;
  white-space: nowrap;
  width: 100%;
  /* border-bottom: 1px solid var(--color-text-lighter); */
  text-align: left;
`;

const sectionGap = '8vw';

export const SectionContent = styled.div`
  display: flex;
  gap: ${sectionGap};
  width: 100%;
  flex-shrink: 1;
  min-height: 0;
  flex-wrap: wrap;
`;

export const Panel = styled.div<{ $width?: string }>`
  display: flex;
  flex-direction: column;
`;

export const PanelGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${sectionGap};
`;

const paddingLeft = '8px';

export const PanelTitle = styled.div`
  font-family: Jost-SemiBold, sans-serif;
  font-size: min(max(3.5vw, 1.5em), 1.2em);
  margin-left: ${paddingLeft};
  margin-bottom: 3px;
  white-space: nowrap;
  text-align: left;
`;

export const PanelContent = styled.div`
  padding-left: ${paddingLeft};
  border-left: 1px solid var(--color-text);
`;
